import {
  LiveBetterRoot,
  LiveBetterContainer,
  Header,
  FeaturesContainer,
  ImageColumn,
  CopyColumn,
  Feature,
  Label,
  Description,
} from './LiveBetter.styles'
import Image from 'next/image'
import { useTranslation } from 'hooks/useTranslation'
import rawCuts from '../../../../../public/assets/home/live-better.webp'
import rawCutsMobile from '../../../../../public/assets/home/live-better-m.webp'
import { features } from './features'

export const LiveBetter = () => {
  const { t } = useTranslation()

  return (
    <LiveBetterRoot>
      <LiveBetterContainer>
        <Header>{t('home:live-better.title')}</Header>
        <FeaturesContainer>
          <ImageColumn>
            <div className="d-only">
              <Image
                layout="fill"
                objectFit="cover"
                src={rawCuts}
                alt={t('home:properties.image')}
              />
            </div>
            <div className="m-only">
              <Image
                layout="fill"
                objectFit="cover"
                src={rawCutsMobile}
                alt={t('home:properties.image')}
              />
            </div>
          </ImageColumn>
          <CopyColumn>
            {features.map(({ label, description }, index) => (
              <Feature key={index}>
                <Label weight="semiBold">{t(label)}</Label>
                <Description>{t(description)}</Description>
              </Feature>
            ))}
          </CopyColumn>
        </FeaturesContainer>
      </LiveBetterContainer>
    </LiveBetterRoot>
  )
}
